var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        {},
        [
          _c("Top"),
          _vm._v(" "),
          _vm.oddOrEven === "odd"
            ? _c("div", { staticClass: "img-banner-odd" }, [
                _c("div", { staticClass: "img-banner-text-odd" }, [
                  _c("img", {
                    staticClass: "img-fam img-fluid",
                    attrs: {
                      src: require("@/assets/img/family.svg?data"),
                      alt: "Bild på familj"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "p-bannertext",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.landingpage.bannertext)
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.oddOrEven === "even"
            ? _c("div", { staticClass: "img-banner-even" }, [
                _c("div", { staticClass: "img-banner-text-even" }, [
                  _c("img", {
                    staticClass: "img-fam img-fluid",
                    attrs: {
                      src: require("@/assets/img/family.svg?data"),
                      alt: "Bild på familj"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "p-bannertext",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.landingpage.bannertext)
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-sm-7",
                  class: { "order-1": _vm.isPhoneMediaQuery },
                  attrs: { id: "col-middle" }
                },
                [
                  _c("div", { staticClass: "d-card" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.landingpage.welcometext)
                      }
                    }),
                    _vm._v(" "),
                    _c("hr", { staticClass: "hr-399bc8" }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.landingpage.abouttext)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "hr-399bc8" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-card",
                      class: { "order-5": _vm.isPhoneMediaQuery }
                    },
                    [_vm._m(0)]
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "hr-399bc8" }),
                  _vm._v(" "),
                  _c("div", { class: { "order-4": _vm.isPhoneMediaQuery } }, [
                    _c("p", {
                      staticClass: "p-scroll",
                      domProps: {
                        innerHTML: _vm._s(_vm.data.landingpage.newstext)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "hr-399bc8" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-content",
                      class: { "order-3": _vm.isPhoneMediaQuery }
                    },
                    [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.data.landingpage.linkstext)
                        }
                      })
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _vm._m(2)
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }, [
        _c("small", [_vm._v("Illustration förekomst FH")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "/static/img/screening-funnel.732e82b.svg",
              title: "Öppna förekomst av FH i ny flik",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/img/screening-funnel.svg?data"),
                alt: "Illustration förekomst av FH"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }, [
        _c("small", [_vm._v("Flödesschema för indexpatienter")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "/static/img/flowchart-index.1ceccfa.svg",
              title: "Öppna flödesschema i ny flik",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/img/flowchart-index.svg?data"),
                alt: "Flödesschema index"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("small", [_vm._v("Flödesschema för gennegativa patienter")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "/static/img/flowchart-scr.1c1149c.svg",
              title: "Öppna flödesschema i ny flik",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/img/flowchart-scr.svg?data"),
                alt: "Flödesschema gennegativa"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }, [
        _c("small", [_vm._v("Flödesschema för kardiologpatienter")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "/static/img/flowchart-cardio.b2b8ea6.svg",
              title: "Öppna flödesschema i ny flik",
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/img/flowchart-cardio.svg?data"),
                alt: "Flödesschema kardiolog"
              }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f74f74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f74f74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage.vue
// module id = null
// module chunks = 